
import React, { Component } from "react";
import PageTitle from "../Components/Theme/PageTitle/index.js";
import DashboardLayout from "../Components/Theme/DashboardLayout/index.js";
import SelectDayTypeResourceInfoCard from '../Components/DayType/SelectDayTypeResource/SelectDayTypeResourceInfoCard.js';
import { Col, Row, Modal, Divider } from "antd";
import { InfoCard } from "../Components/Theme/Cards/index.js";
import { Link, useNavigate } from 'react-router-dom';
import Spinner from '../Components/Theme/Spinner/index.js';
import { StrokeIcon } from "../Components/Theme/Icon/index.js";
import dayjs from "dayjs";
import * as WrappedDayTypeCalendarForm from '../Components/DayType/DayTypeCalendarForm.js';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from "redux";
import * as dayTypeActions from '../redux/actions/dayTypeActions.js';
import * as resourceActions from '../redux/actions/resourceActions.js';
import generateCalendarEvents from '../Components/DayType/utils/generate-events.js'
import AuthLogic from '../AuthLogic/index.js';


export class DayTypesPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            calendarViewModal: false,
            calendarStartDate: dayjs().startOf('year'),
        }
    }

    showCalendarViewModal = () => {
        this.setState({
            calendarViewModal: true,
        });
    };

    handleCalendarViewModalCancel = (e) => {
        this.setState({
            calendarViewModal: false
        });
    };

    handleCalendarStartDateChange = date => {
        this.setState({
            calendarStartDate: date || dayjs()
        });
    };

    handleCalendarFormSubmit = async (values) => {
        this.handleCalendarViewModalCancel()
        this.setState({
            calendarStartDate: this.state.calendarStartDate
        });
        this.props.navigate('/day-types-calendar-view',{state: {startDate: this.state.calendarStartDate}});
    };

    updateResource = () => {
        this.setState({
            resource: this.props.selectedDayTypeResource,
            loaded: false
        }, () => {
            console.log(`resourceName: ${this.state.resource.name}, resourceId: ${this.state.resource.id}`);
        });
    }

    render() {
        if (!this.props.user) {
            <Redirect
                to={{
                    pathname: '/'
                }}
            />
        }
        if (this.props.user.securityLevels) {
            return (
                <DashboardLayout>

                    <PageTitle title={'Days Off and Availability'}
                        subTitle={ // show logged in user or selectedDayTypeResource
                            this.props.selectedDayTypeResource.name
                                ? this.props.selectedDayTypeResource.name
                                : this.props.user.userDemographics.name
                        } />

                    <Row gutter={32}>
                        {AuthLogic.addDayTypeRequest(this.props.user)&&<Col lg={8} md={24} xs={18} >
                            <Link to="/day-types-requests-view">
                                <InfoCard icon={<StrokeIcon icon={'plane'} />}
                                    value={'My Day Off Requests'} /></Link>
                        </Col>}

                        {AuthLogic.viewCalendar(this.props.user) &&
                            <Col lg={8} md={24} xs={18}>
                                <Link to="#" onClick={this.showCalendarViewModal}>
                                    <InfoCard icon={<StrokeIcon icon={'date'} />}
                                        value={'My Calendar View'} /></Link>
                            </Col>
                        }
                        {
                            AuthLogic.changeAbsencesResource(this.props.user) &&
                            <SelectDayTypeResourceInfoCard updatePageCallback={this.updateResource} />
                        }

                        <Modal
                            open={this.state.calendarViewModal}
                            title="Select Start Date for Calendar View"
                            zIndex={2000}
                            onCancel={this.handleCalendarViewModalCancel}
                            footer={[

                            ]}
                        >
                            <Divider />
                            <WrappedDayTypeCalendarForm.default
                                calendarStartDate={this.state.calendarStartDate}
                                handleStartDateChange={this.handleCalendarStartDateChange}
                                handleCalendarFormSubmit={this.handleCalendarFormSubmit}
                            />
                            <Divider />

                        </Modal>
                    </Row>

                </DashboardLayout>
            )
        } else
            return <Spinner />
    }
}

DayTypesPage.propTypes = {
    user: PropTypes.object.isRequired,
    dayTypeCalendar: PropTypes.object,
    dayTypeSecurity: PropTypes.object
};

function mapStateToProps(state) {
    return {
        user: state.user,
        selectedDayTypeResource: state.selectedDayTypeResource,
        dayTypeCalendar: state.dayTypeCalendar,
        dayTypeSecurity: state.dayTypeSecurity
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            fetchDayTypeCalendar: bindActionCreators(
                dayTypeActions.fetchDayTypeCalendar,
                dispatch
            ),
            updateSelectedDayTypeResource: bindActionCreators(
                resourceActions.updateSelectedDayTypeResource,
                dispatch
            ),
            fetchDayTypeSecurity: bindActionCreators(
                dayTypeActions.fetchDayTypeSecurity,
                dispatch
            )
        }
    };
}

export const withRouter = (Component) => {
    const Wrapper = (props) => {
    const navigate = useNavigate();
        return <Component navigate={navigate} {...props}  />;
    };
    return Wrapper;
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(DayTypesPage));
